export default {
  placeholder: 'Wählen Sie eine Farbe',
  color: {
    custom: 'Benutzerdefiniert',
  },
  family: {
    black: 'Schwarz',
    gray: 'Grau',
    slate: 'Blaugrau',
    red: 'Rot',
    orange: 'Orange',
    yellow: 'Gelb',
    green: 'Grün',
    teal: 'Blaugrün',
    cyan: 'Cyan',
    blue: 'Blau',
    indigo: 'Indigo',
    purple: 'Violette',
    pink: 'Pink',
  },
};
